import axios from "../http/axios";

export default {
  searchAddress: (data) => {
    return axios
      .get(`/v1/endereco/${data.cep}`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        return res.data;
      });
  },
  getEstados: () => {
    return axios
      .get(`/v1/endereco/uf/`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        return res.data;
      });
  },
  getProvincias: (data) => {
    return axios
      .get(`/v1/endereco/uf/${data.uf}/provincia`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        return res.data;
      });
  },
  getCidadesByUf: (data) => {
    return axios
      .get(`/v1/endereco/uf/${data.uf}/municipio`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        return res.data;
      });
  },
  getCidadesByProvincia: (data) => {
    return axios
      .get(`/v1/endereco/uf/${data.uf}/provincia/${data.provincia}/municipio`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        return res.data;
      });
  },
  getTiposVia: () => {
    return axios
      .get(`/v1/endereco/tipo-logradouro`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        return res.data;
      });
  },
};
